"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const Dialog_1 = __importDefault(require("app/Components/UI/Dialog"));
const Modal_1 = __importDefault(require("app/Components/UI/Modal"));
const Hooks_1 = require("app/Hooks");
const react_redux_1 = require("react-redux");
const dialogModal_1 = require("app/Redux/Actions/dialogModal");
const loginModal_1 = require("app/Redux/Actions/loginModal");
const useOnOutsideClick_1 = require("app/Hooks/useOnOutsideClick");
const LogoutModal = () => {
    const { t } = (0, Hooks_1.useTranslate)();
    const dispatch = (0, react_redux_1.useDispatch)();
    const wrapperRef = (0, react_1.useRef)();
    const handleCloseModal = () => {
        dispatch((0, dialogModal_1.setIsLogoutModalOpen)(false));
    };
    const handleConfirm = () => {
        handleCloseModal();
        dispatch((0, loginModal_1.setLoginModalState)({
            isLoginModalOpen: true,
            useRedirect: false,
            refreshPage: false
        }));
    };
    (0, useOnOutsideClick_1.useOnOutsideClick)(wrapperRef, handleCloseModal);
    return (react_1.default.createElement(Modal_1.default, null,
        react_1.default.createElement("div", { ref: wrapperRef },
            react_1.default.createElement(Dialog_1.default, { title: t('/haldex/logout/title'), message: t('/haldex/logout/message'), confirmText: t('/haldex/logout/confirm'), onClose: handleCloseModal, onConfirm: handleConfirm }))));
};
exports.default = LogoutModal;
